import { Card } from '@tremor/react';

interface Props {
  /** Number of placeholder rows. Pick something close to what the real
   *  table will render so there's no jarring reflow. Defaults to 5. */
  rows?: number;
  /** Number of placeholder columns — drives the header strip. Defaults to 4. */
  cols?: number;
  /** Skip the Card wrapper when the page already provides one (e.g. when
   *  the skeleton goes inside an existing card section). */
  bare?: boolean;
}

/**
 * Pulsing placeholder for table-shaped data while the first fetch is in
 * flight. Same dimensional footprint as Tremor Tables so swapping the
 * skeleton out for real rows doesn't shift the viewport.
 */
export default function TableSkeleton({ rows = 5, cols = 4, bare }: Props) {
  const body = (
    <div className="animate-pulse space-y-2" aria-busy="true" aria-live="polite">
      <div className="flex gap-3 border-b border-tremor-border pb-2">
        {Array.from({ length: cols }).map((_, i) => (
          <div
            key={i}
            className="h-3 bg-tremor-background-muted rounded flex-1"
          />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3 py-2">
          {Array.from({ length: cols }).map((_, c) => (
            <div
              key={c}
              className="h-3 bg-tremor-background-muted rounded flex-1"
            />
          ))}
        </div>
      ))}
    </div>
  );
  return bare ? body : <Card>{body}</Card>;
}
